module.exports = __webpack_public_path__ + "img/GamesCom3.bfde7072.jpg";